module.exports = __webpack_public_path__ + "img/culture_6.565e647e.jpg";